import GenerarFechasCitas from '../views/utils/GenerarFechasCitas.vue'
import CargaArchivo from '../views/utils/CargaArchivo.vue'
import CargarArchivos from '../views/utils/CargarArchivos.vue'
import CargarArchivo from '../views/utils/CargarArchivo.vue'
import PayPal from '../views/utils/PayPal/PayPal.vue'
import PayToPlace from '../views/utils/PayToPlace/PayToPlace.vue'
import Kushki from '../views/utils/Kushki/Kushki.vue'
import Crecimiento from '../views/utils/Crecimiento.vue'
import VacunaPlan from '../views/utils/VacunaPlan.vue'
import VacunaPersTabla01 from '../views/utils/VacunaPersTabla01.vue'
import VacunaPersTabla02 from '../views/utils/VacunaPersTabla02.vue'
import VacunaPersTabla03 from '../views/utils/VacunaPersTabla03.vue'
import ActualizarClave from '../views/regLog/ActualizarClave.vue'

const vacunaTablaProps = () => ({
  p_idPersona:  Number(window.history.state?.idPersona),
  p_idAtencion: Number(window.history.state?.idAtencion),
  p_numero:     window.history.state?.numero,
  p_edad:       Number(window.history.state?.edad),
});

export default [
{
  path: '/generarfechascitas',
  name: 'GenerarFechasCitas',
  component: GenerarFechasCitas
},
{
  path: '/cargaarchivo',
  name: 'CargaArchivo',
  component: CargaArchivo
},
{
  path: '/cargararchivo',
  name: 'CargarArchivo',
  component: CargarArchivo
},
{
  path: '/cargararchivos',
  name: 'CargarArchivos',
  component: CargarArchivos
},
{
  path: '/paypal',
  name: 'PayPal',
  component: PayPal
},
{
  path: '/paytoplace',
  name: 'PayToPlace',
  component: PayToPlace
},
{
  path: '/kushki',
  name: 'Kushki',
  component: Kushki
},
{
  path: '/crecimiento',
  name: 'Crecimiento',
  component: Crecimiento,
  props: route => ({
    p_idAtencion: parseInt(route.query.p_idAtencion),
    p_idPersona: parseInt(route.query.p_idPersona),
    p_numero: parseInt(route.query.p_numero),
    p_sexo: route.query.p_sexo,
    p_EdadYears: parseInt(route.query.p_EdadYears),
    p_EdadMonths: parseInt(route.query.p_EdadMonths),
    p_EdadDays: parseInt(route.query.p_EdadDays)
  })
},
{
  path: '/vacunaplan',
  name: 'VacunaPlan',
  component: VacunaPlan
},
{
  path: '/vacunaperstabla01',
  name: 'VacunaPersTabla01',
  component: VacunaPersTabla01,
  props: vacunaTablaProps
},
{
  path: '/vacunaperstabla02',
  name: 'VacunaPersTabla02',
  component: VacunaPersTabla02,
  props: vacunaTablaProps
},
{
  path: '/vacunaperstabla03',
  name: 'VacunaPersTabla03',
  component: VacunaPersTabla03,
  props: vacunaTablaProps
},
{
  path: '/actualizarclave',
  name: 'ActualizarClave',
  component: ActualizarClave
},
];